import config from "../../../../config";

export default function HeaderBanner({ dayFilter, clubFilter }) {
  return (
    <div className="header-banner">
      <div>
        <h1>SPIELE</h1>
      </div>
      {(dayFilter && (
        <div>
          <h2>
            SAISON {config.seasonLabel} <br /> {dayFilter}. SPIELTAG{" "}
          </h2>
        </div>
      )) ||
        (clubFilter && (
          <div>
            <h2>
              {" "}
              SAISON {config.seasonLabel} <br /> {clubFilter}
            </h2>
          </div>
        )) || (
          <div>
            <h2>
              SAISON {config.seasonLabel} <br /> ALLE SPIELE
            </h2>
          </div>
        )}
    </div>
  );
}
